import React, {
  useState, useCallback, useEffect,
} from 'react';
import { browserHistory } from 'react-router';
import ImageCapture from '../ImageCapture';
import { isMobile } from '../../common/globals';

const TakePhotoModal = ({
  onTakePhotoFile, params, id
}) => {
  const [cameraError, setCameraError] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  const [facingMode, setFacingMode] = useState(true);

  useEffect(() => {
    const takePhotoModal = document.getElementById('takePhotoModal');
    takePhotoModal.addEventListener('show.bs.modal', () => {
      setShowCamera(true);
      setImgSrc(null);
    });
    takePhotoModal.addEventListener('hide.bs.modal', () => {
      setShowCamera(false);
    });
  }, []);

  const onCapture = (imageData) => {
    // read as webP
    setImgSrc(imageData.webP);
    setImgFile(
      new File([imageData.blob], `${new Date().getTime()}.png`, { type: 'image/png' })
    );
    setShowCamera(false);
  };

  const onError = useCallback(() => {
    // alert(JSON.stringify(error));
    setCameraError(true);
  }, []);

  const onSuccess = useCallback(() => {
    setCameraError(false);
  }, []);

  const _onUsePhoto = (() => {
    onTakePhotoFile(imgFile, 'dgr');
    setImgSrc(null);
    setShowCamera(false);
  });

  const _onFlipCamera = (() => {
    setFacingMode(!facingMode);
    setShowCamera(true);
  });

  const _onRetake = (() => {
    setImgSrc(null);
    setShowCamera(true);
  });

  const onClickCancel = () => {
    if (params === 'products/add') {
      browserHistory.push(`/manage-case/${id}/products/dgr`);
    }
  };

  return (
    <div
      className="modal fade theme-modal qty-modal take-video-modal"
      id="takePhotoModal"
      tabIndex="-1"
      aria-labelledby="takePhotoModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* <div className="modal-header pt-0 pb-0" style={{ alignSelf: 'center' }}> */}
          {/*  <h5 className="modal-title" id="takePhotoModalLabel">Take photo</h5> */}
          {/* </div> */}
          <div className="modal-body p-0">
            <div className={`take-video-modal-body-inner ${imgSrc ? 'img-cap' : ''}`}>
              {
              cameraError && (
                <div className="cam-not-found">
                  There was an error with accessing the camera to take photo.
                </div>
              )
            }
              {showCamera && (
                <div className="video-block">
                  <ImageCapture
                    test="test"
                    autoPlay
                    width="100%"
                    height="100%"
                    onCapture={onCapture}
                    onError={onError}
                    onSuccess={onSuccess}
                    userMediaConfig={{ video: { facingMode: facingMode === true ? 'user' : 'environment' } }}
                  />
                </div>
              )}
              {imgSrc && (
              <div className="captured-image">
                <img src={imgSrc} alt="captured-img" />
              </div>
              )}
            </div>
          </div>
          <div className="modal-footer border-top-0">
            <div className="row gx-2 button-wrap">
              {!imgSrc && (
                <>
                  <div className={!isMobile ? 'col-sm' : 'col-6'}>
                    <button
                      type="button"
                      className="btn btn-link w-100"
                      onClick={onClickCancel}
                      data-bs-dismiss="modal"
                    >Cancel
                    </button>
                  </div>
                  {
                    isMobile
                    && (
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-link w-100"
                        onClick={_onFlipCamera}
                      >Camera Flip
                      </button>
                    </div>
                    )
                   }
                </>
              )}
              {imgSrc && (
                <>
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-link w-100"
                      onClick={_onRetake}
                    >Retake
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-link w-100"
                      onClick={_onUsePhoto}
                    >Use Photo
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TakePhotoModal;
